import styled from "styled-components";

const SectionContainer = styled.section`
  padding: 80px 124px;
  background: #09100F;
  color: #fff;
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 1440px;
  .salary-hero-br-shape {
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: -1;
    height: 100%;
  }
  .container {
    padding: 0 15px;
    margin: 0 auto;
    width: 100%;
  }
  .salary-hero-section__inner {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
  }
  .salary-hero__content {
    max-width: 700px;
  }
  .default-button {
    padding: 5px 17px;
    min-height: 41px;
    border-radius: 5px;
    gap: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    background: #fff;
    color: #09100F;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 17px;
    transition: 0.3s;
    border: 1px solid transparent;
  }
  .salary-hero__content h1 {
    margin-bottom: 8px;
    font-size: 96px;
    font-style: normal;
    font-weight: 300;
    line-height: 86px;
    letter-spacing: -3.84px;
    position: relative;
  }
  .salary-hero__content h1 .stl-1 {
    font-style: italic;
    font-weight: 400;
    font-family: var(--IvJournal);
    background: linear-gradient(90deg, #FF7369 0%, #D83848 111.81%);
      background-clip: border-box;
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    padding: 20px;
    margin: -20px;
  }
  .salary-hero__content p {
    font-size: 16px;
    font-style: normal;
    font-weight: 300;
    line-height: 24px;
    color: #F9F8F5;
  }
  .salary-hero__content h1 .h1-shape {
    position: absolute;
    top: -40px;
    left: 204px;
  }
`;

export default SectionContainer;